import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=4e8e138e&scoped=true&%3Aclass=%7B%20eopisto%3A%20serviceName%20%3D%3D%3D%20'E-opisto.fi'%20%7D"
import script from "./logo.vue?vue&type=script&lang=ts"
export * from "./logo.vue?vue&type=script&lang=ts"
import style0 from "./logo.vue?vue&type=style&index=0&id=4e8e138e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e138e",
  null
  
)

export default component.exports